import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import { payment_status } from "../../utils/data/data";
import { showToast } from "../../utils/utils";
import {
  InvoiceDetails,
  buttonName,
  fieldValidation,
  responseStatus
} from "./../../locales/en";
import privateAxios from "../../utils/axiosPrivate";
import DatePicker from "./../../components/datepicker/ModalDatePicker";
import PropTypes from "prop-types";
import Modalstyle from "./modal.module.scss";
import { showToastType, yyyyMMdd } from "../../utils/constants/appConstants";
import {
  getPaySyncPaymentsPut,
  getPaySyncPaymentsUrl
} from "../../utils/constants/apiEndPoints";
import CommonModal from "./CommonModal";

export const PaymentModal = ({
  isOpen,
  toggle,
  defaultValues,
  quoteId,
  invData,
  loadPaymentData,
  editMode
}) => {
  const [paymentDate, setPaymentDate] = useState("");
  const [amount, setAmount] = useState("");
  const [xeroStatus, setXeroStatus] = useState(
    InvoiceDetails?.paymentSection?.paymentModal?.xeroStatus
  );
  const [paymentDateError, setPaymentDateError] = useState("");
  const [amountError, setAmountError] = useState("");
  const [userAccountId, setUserAccountId] = useState("");

  // Set default values when the modal opens
  useEffect(() => {
    if (defaultValues && defaultValues.paymentDate) {
      setPaymentDate(new Date(defaultValues.paymentDate));
      setAmount(String(defaultValues.amount).replace(/[^\d.]/g, "") || "");
      setXeroStatus(
        defaultValues.xeroStatus ||
          InvoiceDetails?.paymentSection?.paymentModal?.xeroStatus
      );
    } else {
      setPaymentDate(new Date());
      setAmount("");
      setXeroStatus(InvoiceDetails?.paymentSection?.paymentModal?.xeroStatus);
    }
    setUserAccountId(invData?.userAccountId || "");
  }, [defaultValues]);

  const handleDateChange = (newDate) => {
    setPaymentDate(newDate);
    setPaymentDateError("");
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value) || value === "") {
      setAmount(value);
      setAmountError("");
    }
  };

  const handleSelectChange = (e) => {
    setXeroStatus(e.target.value);
  };

  const handleSubmit = async () => {
    if (!paymentDate) {
      setPaymentDateError(`${fieldValidation?.required}`);
      return;
    }
    if (!amount) {
      setAmountError(`${fieldValidation?.required}`);
      return;
    }

    const formattedDate = format(paymentDate, yyyyMMdd);

    const sendData = {
      paymentDate: formattedDate,
      amount: parseFloat(amount),
      paymentStatus: xeroStatus
    };

    try {
      let response;
      if (defaultValues && defaultValues.id) {
        response = await privateAxios.put(
          getPaySyncPaymentsPut(defaultValues.id),
          sendData
        );
      } else {
        // Add mode
        response = await privateAxios.post(getPaySyncPaymentsUrl, sendData, {
          params: {
            quoteId: quoteId,
            userAccountId: userAccountId
          }
        });
      }
      showToast(response?.data?.message, responseStatus?.success);

      loadPaymentData();
      // Clear fields after submission
      setPaymentDate(new Date());
      setAmount("");
      setPaymentDateError("");
      setAmountError("");
      toggle();
    } catch (err) {
      showToast(
        err.response?.data?.message || responseStatus?.errorText,
        showToastType.error
      );
    }
  };

  const handleClose = () => {
    setPaymentDateError("");
    setAmountError("");
    toggle();
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={
        editMode
          ? InvoiceDetails?.paymentSection?.paymentModal?.updatePayment
          : InvoiceDetails?.paymentSection?.paymentModal?.title
      }
      bodyClassName={Modalstyle.commentModalWrap}
      footerButtons={[
        {
          label: buttonName.close,
          className: "btn btn-secondary",
          onClick: handleClose
        },
        {
          label: buttonName.submit,
          className: "btn btn-primary",
          onClick: handleSubmit
        }
      ]}
    >
      <div className="row">
        <div className="mb-3">
          <div className={Modalstyle.modalInputwrap}>
            <label htmlFor="" className="form-label">
              {InvoiceDetails?.paymentSection?.paymentModal?.paymentDate}
            </label>
            <div className={Modalstyle.formInput}>
              <DatePicker value={paymentDate} onChange={handleDateChange} />
              {paymentDateError && (
                <div className="text-danger small">{paymentDateError}</div>
              )}
            </div>
          </div>
        </div>
        <div className="mb-3">
          <div className={Modalstyle.modalInputwrap}>
            <label htmlFor="" className="form-label">
              {InvoiceDetails?.paymentSection?.paymentModal?.amount}
            </label>
            <div className={Modalstyle.formInput}>
              <input
                type="text"
                name="payment_amount"
                value={amount}
                onChange={handleAmountChange}
              />
              {amountError && (
                <div className="text-danger small">{amountError}</div>
              )}
            </div>
          </div>
        </div>
        <div className="mb-3">
          <div className={Modalstyle.modalInputwrap}>
            <label htmlFor="" className="form-label">
              {InvoiceDetails?.paymentSection?.paymentModal?.paymentStatus}
            </label>
            <div className={Modalstyle.formInput}>
              <select
                name="xeroStatus"
                value={xeroStatus}
                onChange={handleSelectChange}
              >
                {payment_status &&
                  payment_status.map((element) => (
                    <option key={element.id} value={element.value}>
                      {element.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};
PaymentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  editMode: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  defaultValues: PropTypes.object,
  invData: PropTypes.any,
  quoteId: PropTypes.any,
  loadPaymentData: PropTypes.any
};
